import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button } from '@lt/components';

import Icon from '../../../../components/Icon';
import { NBSP } from '../../../../constants/common';

import {
  formatDateToDayWithMonth,
  convertClientDateToServerDate,
} from '../../../../utils/dateUtils';

import styles from './searcher.module.css';

// TODO: можно унифицировать блок
const SearcherEmptyRequest = ({ isMobile, date, onClick }) => {
  const parseDate = convertClientDateToServerDate(date);
  const dateText = formatDateToDayWithMonth(parseDate);

  return (
    <div
      className={classnames(styles.searcherEmptyRequestContainer, {
        [styles.searcherEmptyRequestContainerMobile]: isMobile,
      })}
    >
      <Icon
        className={styles.searcherEmptyRequestIcon}
        type="searcher-empty-request"
        width="129px"
        isMobile={isMobile}
      />
      <div
        className={classnames(styles.searcherEmptyRequestHeader, {
          [styles.searcherEmptyRequestHeaderMobile]: isMobile,
        })}
      >
        {`Узнайте актуальные цены на${NBSP}туры с${NBSP}вылетом ${dateText}`}
      </div>
      <Button
        className={styles.searcherEmptyRequestButton}
        onClick={() => onClick(date)}
        size="large"
      >
        {`Показать туры на ${dateText}`}
      </Button>
    </div>
  );
};

SearcherEmptyRequest.propTypes = {
  isMobile: PropTypes.bool,
  date: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
SearcherEmptyRequest.defaultProps = {
  isMobile: false,
};

export default SearcherEmptyRequest;
